import React from 'react';

import classnames from 'classnames';

import { PopoeverMenuKeys } from 'components/SideNavbar/SideNavbar';
import Badge from '@lotlinx-aws/sparky-component-library/Sparky/Badge';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import styles from './SidebarLink.module.scss';
import Tooltip from '@lotlinx-aws/sparky-component-library/Sparky/Tooltip';
import { IconCircle, IconCircleFilled } from '@tabler/icons-react';

export interface SidebarLinkProps {
  icon: React.ReactElement;
  buttonKey?: PopoeverMenuKeys | undefined;
  text: string;
  text2?: string;
  popoverMenu: PopoeverMenuKeys | undefined;
  setPopoverMenu: (e: PopoeverMenuKeys | undefined) => void;
  handleClick?: () => void;
  badgeContent?: React.ReactNode;
  hideText?: boolean;
  trigger: 'hover' | 'click';
  enableTooltip?: boolean;
  dark?: boolean;
  showBadge?: boolean;
  notificationIndicator?: boolean;
}

/**
 * SidebarLink
 */
export default function SidebarLink({
  icon,
  buttonKey,
  text,
  text2,
  setPopoverMenu,
  handleClick,
  popoverMenu,
  badgeContent,
  hideText = false,
  trigger,
  enableTooltip,
  dark = false,
  notificationIndicator = false,
}: SidebarLinkProps) {
  const handleMouseEnter = () => {
    if (trigger === 'hover') {
      if (buttonKey) {
        setPopoverMenu(buttonKey);
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return (
    <Tooltip disabled={!enableTooltip} content={text2 ? `${text} ${text2}` : text} side='right'>
      <div
        className={styles.sidebarLink}
        onMouseEnter={handleMouseEnter}
        onClick={handleClick}
        data-track={`nav_sidebar_${buttonKey ?? text.toLowerCase().replace(/\s+/g, '_')}`}
        data-track-section='sidebar'
        data-track-target='open_menu'
      >
        <div
          className={classnames([
            styles.IconContainer,
            popoverMenu === buttonKey && styles.active,
            dark && styles.active,
          ])}
        >
          {icon}

          {notificationIndicator && (
            <div className={styles.notificationIndicator}>
              <IconCircleFilled size={12} color='var(--chip-blue)' />
            </div>
          )}

          {badgeContent && (
            <Badge
              className={classnames([
                styles.badgeContainer,
                badgeContent.toString().length > 2 && styles.large,
              ])}
            >
              <Text as='div' lineHeight='1' size={12} fontWeight={5}>
                {badgeContent}
              </Text>
            </Badge>
          )}
        </div>
        {!hideText && (
          <>
            <Text size={12} fontWeight={5} alignment='center' textWrap='nowrap'>
              {text}
            </Text>
            {text2 && (
              <Text size={12} fontWeight={5} alignment='center'>
                {text2}
              </Text>
            )}
          </>
        )}
      </div>
    </Tooltip>
  );
}
